import { render, staticRenderFns } from "./MusicAlbum.vue?vue&type=template&id=34484f3f&scoped=true&"
import script from "./MusicAlbum.vue?vue&type=script&lang=js&"
export * from "./MusicAlbum.vue?vue&type=script&lang=js&"
import style0 from "./MusicAlbum.vue?vue&type=style&index=0&id=34484f3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34484f3f",
  null
  
)

export default component.exports